declare global {
  interface Window {
    __PORTFOLIO_CONFIG_READY__?: Promise<void>;
  }
}

// The server populates this promise before the application (and its Supabase
// client) is evaluated. A static export can still load without server config.
await window.__PORTFOLIO_CONFIG_READY__;
await import("./frontend.tsx");
